import { typographyTokens } from '../../../theme/typographyTokens';
import React, { useState } from 'react';
import { Box, Button, CircularProgress, Drawer } from '@mui/material';
import AddButton from '../../../components/Admin/AddButton';
import KnockoutScreenCard from '../../../components/Admin/KnockoutScreens/KnockoutScreenCard';
import { useGetKnockoutScreenTemplateQuery } from '../../../services/knockoutSlice';
import { KnockoutScreenTemplate } from '../../../../shared/types/Knockout';
import ModalWidget from '../../../components/ModalWidget/ModalWidget';
import AddKnockoutScreen from '../../../components/Admin/KnockoutScreens/AddKnockoutScreen';
import AdminHeader from '../../../components/Admin/AdminHeader';
import { DrawerFilters } from '../DrawerFilters/DrawerFilters';

const initKnockoutScreen: KnockoutScreenTemplate = {
  id: 0,
  name: '',
  stepperTitle: '',
  knockoutScreenDataFields: [],
  template: true,
  createdBy: new Date().toString(),
  sepID: 0,
  complete: false,
  createdAt: new Date().toDateString(),
  updatedAt: new Date().toDateString(),
};

const KnockoutScreens = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedKnockoutScreen, setSelectedKnockoutScreen] =
    useState<KnockoutScreenTemplate>(initKnockoutScreen);
  const { data, isLoading } = useGetKnockoutScreenTemplateQuery();
  // Get max Order number...
  const maxOrder = data
    ? Math.max(
        ...data.filter((entry) => entry.starter).map((e) => e.order || 0)
      )
    : 0;
  const [drawOpen, setDrawOpen] = useState<boolean>(false);
  const [filterData, setFilterData] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState<any>(null);

  const buttonStyles = {
    "&.MuiButton-outlined": {
      border: "2px solid #2372B9",
      color: "#2372B9",
      textTransform: "none",
      fontWeight: typographyTokens.fontWeights.bold,
      height: "min-content",
      alignSelf: "center",
      marginRight: "10px",
    },
  };
  const filterDataFields = (data: any, selectedItem: any) => {
    setFilterData(data);
    setAppliedFilter(selectedItem);
  };
  const isFilterData = filterData?.length > 0 ? filterData : data;

  return (
    <Box sx={{ minHeight: "500px" }}>
      <Box
        sx={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "20px",
        }}
      >
        <Box>
          <AdminHeader title="Knockout Screens" />
        </Box>
        <Box
          sx={{
            display: "flex",
            minWidthidth: "210px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {filterData.length > 0 && (
            <Button
              variant="outlined"
              size="small"
              sx={buttonStyles}
              onClick={() => {
                setFilterData([]);
                setAppliedFilter(null);
              }}
            >
              Reset Filter
            </Button>
          )}
          <Button
            variant="outlined"
            size="small"
            sx={buttonStyles}
            onClick={() => setDrawOpen(true)}
          >
            <i
              className="fa-regular fa-filter"
              style={{ paddingRight: "5px" }}
            ></i>
            Filter Knockout Screens
          </Button>
          <Drawer open={drawOpen}>
            <DrawerFilters
              setDrawOpen={setDrawOpen}
              isFilterData={filterDataFields}
              dataFields={data}
              labelName={"Knockout Screen Template"}
              appliedFilter={appliedFilter}
            />
          </Drawer>
          <AddButton
            tab="Knockout Screen"
            onAdd={(tab: string) => {
              setSelectedKnockoutScreen({
                ...initKnockoutScreen,
                order: maxOrder + 1,
              });
              setIsOpen(true);
            }}
          />
        </Box>
      </Box>
      <ModalWidget
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`${
          selectedKnockoutScreen.name === '' ? 'Add' : 'Edit'
        } Knockout Screen`}
        children={
          <AddKnockoutScreen
            onClose={() => setIsOpen(false)}
            knockoutScreen={selectedKnockoutScreen}
            newOrder={maxOrder + 1}
          />
        }
      />
      {isLoading ? (
        <Box pt={10} sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress data-testid="loading-spinner" size={100} />
        </Box>
      ) : (
        <>
          {isFilterData &&
            [
              ...isFilterData
                ?.filter((e) => e.starter)
                .sort((a, b) => {
                  const aOrder: number = a.order || 0;
                  const bOrder: number = b.order || 0;
                  return aOrder - bOrder;
                }),
              ...isFilterData?.filter((e) => !e.starter),
            ].map((knockoutScreen: KnockoutScreenTemplate, key) => {
              return (
                <KnockoutScreenCard
                  key={key}
                  knockoutScreen={knockoutScreen}
                  onEditTriggered={(e: KnockoutScreenTemplate) => {
                    setSelectedKnockoutScreen(e);
                    setIsOpen(true);
                  }}
                  index={key}
                />
              );
            })}
        </>
      )}
    </Box>
  );
};

export default KnockoutScreens;
